// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JwzX","field":"styles_field__eZC9y","fieldCol":"styles_fieldCol__370zx","diffCol":"styles_diffCol__22t7G","diff":"styles_diff__1H0GB"};